const id = require('./id');

module.exports = {
	...id,
	name: 'itemModel'
};
